import imgGif from '../../pic/try.jpg'
import imgGif2 from '../../pic/try.jpg'


export default function Section2(){
    return(
        <div className='relative bg-[#578CA3] text-white'>
            <img src={imgGif} alt="" className=' w-screen lg:h-full md:h-96 h-[28rem] 
            absolute 
            lg:block md:block hidden
            z-10' />
            <img src={imgGif2} alt="" className=' w-screen lg:h-96 md:h-96 h-full 
            absolute 
            lg:hidden md:hidden block
            z-10' />
            <div className='relative w-full h-full z-50 
         md:bg-black lg:bg-black 
            lg:bg-opacity-10  md:bg-opacity-10 bg-opacity-50
            pb-2'>
                <div className=' flex flex-col w-full justify-center align-middle lg:py-20 md:py-16 py-4  lg:px-40 md:px-20 px-8'>
                    <h1 className='
                    text-white
                    lg:text-6xl md:text-4xl text-4xl 
                    lg:text-start md:text-start text-center
                    mb-4'>Hello</h1>
                    <p className='

                    w-full 
                    lg:text-2xl md:text-2xl text-xl 
                    lg:text-start md:text-start text-center font-semibold text-white'>I am one of the members of a scientific club that brings together enthusiasts of the Internet and new technologies.I design and develop websites and web applications. I`m working as a Front-End Developer definitely developed my skills in group work and working under time pressure. If you want to know more about me, click the button below!</p>
                </div>
            </div>
        </div>
    )
}